import React, { Component } from 'react';
import './styles.css';

class BodyRight extends Component {
	render() {
		return (
			<div className="sales-test-layout-body-right">{this.props.children}</div>
		);
	}
}
export default BodyRight;
